import api from '../utils/api'
import { API_ROOT } from '../constants'
import { getDeletedSites } from '../services/site'
import { isMoreThanOneDay } from '../utils/general'
import * as spacesService from '../services/spaces'

export const FETCHING_USER = 'FETCHING_USER'
export const fetchingUser = (payload) => ({
  type: FETCHING_USER,
  payload
})

export const INSERT_USER_PROFILE = 'INSERT_USER_PROFILE'
export const insertUserProfile = (data) => ({
  type: INSERT_USER_PROFILE,
  payload: {
    ...data
  }
})

export const ACCOUNT_MODAL = 'ACCOUNT_MODAL'
export const accountModal = (show) => ({
  type: ACCOUNT_MODAL,
  payload: show
})

export const UPGRADE_MODAL = 'UPGRADE_MODAL'
export const showUpgradeModal = (show) => {
  if (show) {
    window.scrollTo(0, 0)
  }

  return {
    type: UPGRADE_MODAL,
    payload: show
  }
}

export const fetchUserData =
  (loading = true) =>
  (dispatch) => {
    dispatch(fetchingUser(loading))
    return api
      .post(`${API_ROOT}/v3/account/profile`)
      .then(async (res) => {
        const data = res.data
        dispatch(fetchingUser(false))
        dispatch(insertUserProfile(data))

        const { userProfile } = data
        // notify user feedback module
        if (isMoreThanOneDay(userProfile.created)) {
          window.InsightPipeline?.update({ show: true })
        }
      })
      .catch((err) => {
        localStorage.removeItem('token')
        dispatch(fetchingUser(false))
        window.location = '/login'
      })
  }

export const ACTION_PROCESSING = 'ACTION_PROCESSING'
export const actionProcessing = (payload) => ({
  type: ACTION_PROCESSING,
  payload
})

export const SHOW_MESSAGE_MODAL = 'SHOW_MESSAGE_MODAL'
export const showMessageModal = (payload) => ({
  type: SHOW_MESSAGE_MODAL,
  payload
})

export const HIDE_MESSAGE_MODAL = 'HIDE_MESSAGE_MODAL'
export const hideMessageModal = () => ({
  type: HIDE_MESSAGE_MODAL
})

export const CUSTOM_DOMAIN_MODAL = 'CUSTOM_DOMAIN_MODAL'
export const showCustomDomainModal = (payload) => ({
  type: CUSTOM_DOMAIN_MODAL,
  payload
})

export const EMAIL_SUBSCRIPTION_MODAL = 'EMAIL_SUBSCRIPTION_MODAL'
export const showEmailSubscriptionModal = (show, domain = null) => ({
  type: EMAIL_SUBSCRIPTION_MODAL,
  payload: { show, domain }
})

export const PUBLISH_TO_CUSTOM_DOMAIN = 'PUBLISH_TO_CUSTOM_DOMAIN'
export const publishToCustomDomain = (payload) => ({
  type: PUBLISH_TO_CUSTOM_DOMAIN,
  payload
})

export const CUSTOM_DOMAIN_DIAGNOSTICS = 'CUSTOM_DOMAIN_DIAGNOSTICS'
export const customDomainDiagnostics = (payload) => ({
  type: CUSTOM_DOMAIN_DIAGNOSTICS,
  payload
})

export const CREATE_SITE_MODAL = 'CREATE_SITE_MODAL'
export const showCreateSiteModal = (visible, data, action) => ({
  type: CREATE_SITE_MODAL,
  payload: {
    visible,
    data,
    action
  }
})

export const DRAGGED_FILE = 'DRAGGED_FILE'
export const setDraggedFile = (file) => {
  return {
    type: DRAGGED_FILE,
    payload: file
  }
}

export const SITE_TYPE = 'SITE_TYPE'
export const setSiteType = (siteType) => {
  return {
    type: SITE_TYPE,
    payload: siteType
  }
}

export const TOGGLE_MODAL = 'TOGGLE_MODAL'
export const toggleModal = (payload) => {
  return {
    type: TOGGLE_MODAL,
    payload
  }
}

export const TOGGLE_TEAM_MODAL = 'TOGGLE_TEAM_MODAL'
export const toggleTeamModal = (payload) => {
  return {
    type: TOGGLE_TEAM_MODAL,
    payload
  }
}

export const TOGGLE_SELECT_TEAM_OWNER_MODAL = 'TOGGLE_SELECT_TEAM_OWNER_MODAL'
export const toggleSelectTeamOwnerModal = (payload) => {
  return {
    type: TOGGLE_SELECT_TEAM_OWNER_MODAL,
    payload
  }
}

export const SHOW_QRCODE_MODAL = 'SHOW_QRCODE_MODAL'
export const setQrCodeModal = (payload) => {
  return {
    type: SHOW_QRCODE_MODAL,
    payload
  }
}

export const SHOW_FIRST_TIME_MODAL = 'SHOW_FIRST_TIME_MODAL'
export const setFirstTimeSuccModal = (payload) => {
  return {
    type: SHOW_FIRST_TIME_MODAL,
    payload
  }
}

export const SET_QRCODE_DATA = 'SET_QRCODE_DATA'
export const setQrCodeData = (payload) => {
  return {
    type: SET_QRCODE_DATA,
    payload
  }
}

export const SET_EMBED_DATA = 'SET_EMBED_DATA'
export const setEmbedData = (show, site) => {
  return {
    type: SET_EMBED_DATA,
    payload: {
      show: show,
      site: site
    }
  }
}

export const SET_API_KEY = 'SET_API_KEY'
export const setAPIKey = (payload) => {
  return {
    type: SET_API_KEY,
    payload
  }
}

export const SET_ACTION = 'SET_ACTION'
export const setAction = (payload) => {
  return {
    type: SET_ACTION,
    payload
  }
}

export const SHOW_PREVIEW_MODAL = 'SHOW_PREVIEW_MODAL'
export const setPreviewModal = (payload) => {
  return {
    type: SHOW_PREVIEW_MODAL,
    payload
  }
}

export const SET_PREVIEW_DATA = 'SET_PREVIEW_DATA'
export const setPreviewData = (payload) => {
  return {
    type: SET_PREVIEW_DATA,
    payload
  }
}

export const TOGGLE_SIGNUP_MODAL = 'TOGGLE_SIGNUP_MODAL'
export const toggleSignUpModal = (isVisible) => ({
  type: TOGGLE_SIGNUP_MODAL,
  payload: isVisible
})

export const SET_LOADING_SITES_STORE = 'SET_LOADING_SITES_STORE'
export const setLoadingSitesStore = (payload) => ({
  type: SET_LOADING_SITES_STORE,
  payload
})

export const SET_LIVE_SITES_STORE = 'SET_LIVE_SITES_STORE'
export const setLiveSitesStore = (payload) => ({
  type: SET_LIVE_SITES_STORE,
  payload
})

export const RESET_USER_PROFILE = 'RESET_USER_PROFILE'
export const resetUserProfile = () => ({
  type: RESET_USER_PROFILE
})

export const SHOW_ACCOUNT_PASSWORD_MODAL = 'SHOW_ACCOUNT_PASSWORD_MODAL'
export const setAccountPasswordModal = (payload) => ({
  type: SHOW_ACCOUNT_PASSWORD_MODAL,
  payload
})

export const SAVE_FORM_VALUES = 'SAVE_FORM_VALUES'
export const saveFormValues = (payload) => ({
  type: SAVE_FORM_VALUES,
  payload
})

export const IS_PRESIGNED_UPLOAD_IN_PROGRESS = 'IS_PRESIGNED_UPLOAD_IN_PROGRESS'
export const isPresignedUploadInProgress = (payload) => ({
  type: IS_PRESIGNED_UPLOAD_IN_PROGRESS,
  payload
})

export const SHOW_DROPBOX_MODAL = 'SHOW_DROPBOX_MODAL'
export const showDropboxModal = (show) => ({
  type: SHOW_DROPBOX_MODAL,
  payload: show
})

export const FETCHING_DELETED_SITES = 'FETCHING_DELETED_SITES'
export const fetchingDeletedSites = (payload) => ({
  type: FETCHING_DELETED_SITES,
  payload
})

export const INSERT_DELETED_SITES = 'INSERT_DELETED_SITES'
export const insertDeletedSites = (payload) => ({
  type: INSERT_DELETED_SITES,
  payload
})

export const fetchDeletedSites = () => async (dispatch) => {
  dispatch(fetchingDeletedSites(true))
  try {
    const res = await getDeletedSites()
    dispatch(insertDeletedSites(res.data?.trashedLinks || []))
  } catch (error) {
    console.error('Error fetching deleted sites:', error)
  } finally {
    dispatch(fetchingDeletedSites(false))
  }
}

// Spaces Actions
export const FETCHING_SPACES = 'FETCHING_SPACES'
export const fetchingSpaces = (payload) => ({
  type: FETCHING_SPACES,
  payload
})

export const SET_SPACES = 'SET_SPACES'
export const setSpaces = (payload) => ({
  type: SET_SPACES,
  payload
})

export const ADD_SPACE = 'ADD_SPACE'
export const addSpace = (payload) => ({
  type: ADD_SPACE,
  payload
})

export const UPDATE_SPACE = 'UPDATE_SPACE'
export const updateSpaceAction = (payload) => ({
  type: UPDATE_SPACE,
  payload
})

export const REMOVE_SPACE = 'REMOVE_SPACE'
export const removeSpace = (payload) => ({
  type: REMOVE_SPACE,
  payload
})

export const SET_ACTIVE_SPACE = 'SET_ACTIVE_SPACE'
export const setActiveSpace = (payload) => ({
  type: SET_ACTIVE_SPACE,
  payload
})

export const SHOW_CREATE_SPACE_MODAL = 'SHOW_CREATE_SPACE_MODAL'
export const showCreateSpaceModal = (show) => ({
  type: SHOW_CREATE_SPACE_MODAL,
  payload: show
})

export const createSpaceAsync = (spaceData, onSuccess) => async (dispatch) => {
  try {
    dispatch(actionProcessing(true))
    const response = await spacesService.createSpace(spaceData)
    const newSpace = {
      ...response.data.data,
      id: response.data.data.spaceId
    }
    dispatch(showCreateSpaceModal(false))
    dispatch(actionProcessing(false))
    dispatch(addSpace(newSpace))
    const spaceIdString = String(newSpace.id)
    dispatch(setActiveSpace(spaceIdString))
    if (onSuccess) onSuccess(newSpace)
    return newSpace
  } catch (error) {
    dispatch(actionProcessing(false))
    const errorCode = error.code || error.response?.data?.code
    const isDuplicateNameError = errorCode === 'You already have a space with that name.'

    if (!isDuplicateNameError) {
      const errorMessage = errorCode || error.message || 'Failed to create space. Please try again.'
      dispatch(
        showMessageModal({
          title: 'Error',
          message: errorMessage,
          error: true
        })
      )
    }
    throw error
  }
}

export const updateSpaceAsync = (spaceId, spaceData) => async (dispatch) => {
  try {
    dispatch(actionProcessing(true))
    await spacesService.updateSpace(spaceId, spaceData)
    dispatch(actionProcessing(false))
    // Refresh user data to get updated spaces
    dispatch(fetchUserData(false))
  } catch (error) {
    dispatch(actionProcessing(false))
    dispatch(
      showMessageModal({
        title: 'Error',
        message: error.message || 'Failed to update space. Please try again.',
        error: true
      })
    )
    throw error
  }
}

export const deleteSpaceAsync = (spaceId) => async (dispatch) => {
  try {
    dispatch(actionProcessing(true))
    await spacesService.deleteSpace(spaceId)
    dispatch(actionProcessing(false))
    // Refresh user data to get updated spaces and sites
    dispatch(fetchUserData(false))
  } catch (error) {
    dispatch(actionProcessing(false))
    dispatch(
      showMessageModal({
        title: 'Error',
        message: error.message || 'Failed to delete space. Please try again.',
        error: true
      })
    )
    throw error
  }
}

export const assignSiteToSpaceAsync = (subdomain, spaceId) => async (dispatch) => {
  try {
    await spacesService.assignSiteToSpace({ subdomain, spaceId })
    // Refresh user data to get updated site assignments
    dispatch(fetchUserData(false))
  } catch (error) {
    dispatch(
      showMessageModal({
        title: 'Error',
        message: error.message || 'Failed to assign site to space. Please try again.',
        error: true
      })
    )
    throw error
  }
}
